import React, { createContext, useContext, useState, useEffect } from 'react';
import { themes, defaultTheme } from '../data/themes';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(defaultTheme);
  const [themeData, setThemeData] = useState(themes[defaultTheme]);

  useEffect(() => {
    // Try to load theme from API
    fetch('https://ops.genxphotostudioja.com/api/public/site-theme')
      .then(res => res.json())
      .then(data => {
        if (data.theme && themes[data.theme]) {
          setCurrentTheme(data.theme);
          setThemeData(themes[data.theme]);
        }
      })
      .catch(() => {
        // Use default theme if API fails
        console.log('Using default theme');
      });
  }, []);

  const changeTheme = (themeId) => {
    if (themes[themeId]) {
      setCurrentTheme(themeId);
      setThemeData(themes[themeId]);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, themeData, changeTheme, allThemes: themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
